<template lang="pug">
  .stage-indicator(:style="`background: ${color} !important; width: ${size}; height: ${size};`")
</template>

<script>
export default {
  name: 'StageIndicator',
  props: {
    color: {
      type: String,
      default: '#ED1B24'
    },
    size: {
      type: String,
      default: '20px'
    }
  },
  computed: {
    isSelect () {
      return this.to === this.$route.path
    }
  },
  methods: {
    updateBox () {
      this.$router.push(this.to)
    }
  }
}
</script>
<style lang="scss" scoped>
.stage-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 15px 0 15px;
}
</style>
